/**
 * Gets the PerformanceNavigationTiming entry for the current page.
 * Used for accessing prerender activation timing data.
 */
const getNavigationEntry = (): PerformanceNavigationTiming | undefined => {
	if (typeof performance === 'undefined' || typeof performance.getEntriesByType !== 'function') {
		return undefined
	}

	const navigationEntry = performance.getEntriesByType('navigation')[0] as unknown as
		| PerformanceNavigationTiming
		| undefined

	if (navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) {
		return navigationEntry
	}

	return undefined
}

/**
 * Gets the activation start time for prerendered pages.
 *
 * When a page is prerendered via the Speculation Rules API, `activationStart`
 * represents the time when the user actually navigated to the page (activation).
 * For non-prerendered pages, this value is 0.
 *
 * This value should be subtracted from performance.now() to get accurate
 * timing measurements relative to user navigation, not prerender start.
 */
export const getActivationStart = (): number => {
	const navEntry = getNavigationEntry() as (PerformanceNavigationTiming & { activationStart?: number }) | undefined
	return navEntry?.activationStart ?? 0
}
